import { IconType } from '@/types';

export default function OrderIcon({ className, width = 24, height = 24 }: IconType) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 16 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V6C1.69779e-06 5.45 0.196001 4.979 0.588001 4.587C0.980001 4.195 1.45067 3.99933 2 4H4C4 2.9 4.39167 1.95833 5.175 1.175C5.95834 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4H14C14.55 4 15.021 4.196 15.413 4.588C15.805 4.98 16.0007 5.45067 16 6V18C16 18.55 15.804 19.021 15.412 19.413C15.02 19.805 14.5493 20.0007 14 20H2ZM2 18H14V6H12V8C12 8.28333 11.904 8.521 11.712 8.713C11.52 8.905 11.2827 9.00067 11 9C10.7167 9 10.479 8.904 10.287 8.712C10.095 8.52 9.99934 8.28267 10 8V6H6V8C6 8.28333 5.904 8.521 5.712 8.713C5.52 8.905 5.28267 9.00067 5 9C4.71667 9 4.479 8.904 4.287 8.712C4.095 8.52 3.99934 8.28267 4 8V6H2V18ZM6 4H10C10 3.45 9.804 2.979 9.412 2.587C9.02 2.195 8.54934 1.99933 8 2C7.45 2 6.979 2.196 6.587 2.588C6.195 2.98 5.99934 3.45067 6 4Z'
        fill='#45464E'
      />
    </svg>
  );
}
